import { useState, useEffect, RefObject } from 'react';

export const useTableNavigation = (tableContainerReference: RefObject<HTMLDivElement | null>) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  const handlePreviousOption = () => {
    if (tableContainerReference.current) {
      const columnWidth = 200;
      const currentScroll = tableContainerReference.current.scrollLeft;
      const currentColumn = Math.round(currentScroll / columnWidth);
      const targetColumn = Math.max(0, currentColumn - 1);
      const targetScroll = targetColumn * columnWidth;
      tableContainerReference.current.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }
  };

  const handleNextOption = () => {
    if (tableContainerReference.current) {
      const columnWidth = 200;
      const currentScroll = tableContainerReference.current.scrollLeft;
      const currentColumn = Math.round(currentScroll / columnWidth);
      const targetColumn = currentColumn + 1;
      const targetScroll = targetColumn * columnWidth;
      tableContainerReference.current.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const container = tableContainerReference.current;
    if (!container) return;

    const handleScroll = () => {
      setScrollPosition(container.scrollLeft);
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [tableContainerReference]);

  return {
    scrollPosition,
    handlePreviousOption,
    handleNextOption,
  };
};
